import { render, staticRenderFns } from "./RuleProperties.vue?vue&type=template&id=a5fd2bbe&"
import script from "./RuleProperties.vue?vue&type=script&lang=js&"
export * from "./RuleProperties.vue?vue&type=script&lang=js&"
import style0 from "./RuleProperties.vue?vue&type=style&index=0&id=a5fd2bbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports